export const DEFAULT_PREVIEW_SCALE = 0.35;
